export const REGISTER_USER = "REGISTER_USER"
export const REGISTER_USER_SUCCESSFUL = "REGISTER_USER_SUCCESSFUL"
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED"

export const GET_KYC = "GET_KYC"
export const GET_KYC_SUCCESSFULL = "GET_KYC_SUCCESSFULL"
export const GET_KYC_FAILED = "GET_KYC_FAILED"


export const GET_KYC_STATUS = "GET_KYC_STATUS"
export const GET_KYC_STATUS_SUCCESSFULL = "GET_KYC_STATUS_SUCCESSFULL"
export const GET_KYC_STATUS_FAILED = "GET_KYC_STATUS_FAILED"

export const GET_PROFILE = "GET_PROFILE"
export const GET_PROFILE_SUCCESSFUL = "GET_PROFILE_SUCCESSFUL"
export const GET_PROFILE_FAILED = "GET_PROFILE_FAILED"
